import { FC } from 'react'
import styled from '@emotion/styled'
import { Colors } from 'src/components/theme'
import { CircleIcon } from 'src/components/icons/circle-icon'
import { Briefcase } from '@emotion-icons/fa-solid/Briefcase'
import { Typography } from '@mui/material'
import { LinkExternal } from '@emotion-icons/octicons/LinkExternal'
import Link from 'next/link'
import { DarkTooltip } from 'src/components/tooltip/dark-tooltip'
import { useMapExplorerNavigation } from 'src/views/map-explorer/sidebar/search/use-navigation'

const Container = styled.div`
  display: flex;
  gap: 8px;
  border: 1px solid ${Colors.neutral100};
  padding: 8px;
  padding-right: 16px;
  border-radius: 6px;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  :hover {
    background-color: ${Colors.neutral50};
  }
`

const Content = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const EntityType = styled(Typography)`
  text-transform: capitalize;
`

type OwnerItemProps = {
  id: string
  name: string
  type?: string
  link?: string
  onClick?: () => void
}

export const OwnerItem: FC<OwnerItemProps> = ({ id, name, type, link, onClick }) => {
  const { selectOwner } = useMapExplorerNavigation()

  const handleClick = async () => {
    onClick?.()
    await selectOwner(id)
  }

  return (
    <Container onClick={handleClick}>
      <Content>
        <CircleIcon size={30} color={Colors.primaryRed800}>
          <Briefcase size={14} />
        </CircleIcon>
        <div>
          <Typography fontSize={16} color={Colors.neutral700}>
            {name}
          </Typography>
          {type && (
            <EntityType fontSize={14} color={Colors.neutral400}>
              {type.toLowerCase()}
            </EntityType>
          )}
        </div>
      </Content>
      {link && (
        <DarkTooltip title="Open in a new tab" arrow={false} placement="top-end">
          <Link
            href={link}
            target="_blank"
            onClick={(e) => {
              e.stopPropagation()
            }}>
            <LinkExternal size={14} color={Colors.blueDark} cursor="pointer" />
          </Link>
        </DarkTooltip>
      )}
    </Container>
  )
}
